import React from 'react';
import { REBRAND_COLOR } from '@latitude/core/utils/constants';
import {
  StyledTextContainer,
  StyledTextWrapper,
  StyledImageContainer,
  StyledHeroContainer,
  StyledButtonWrapper,
  StyledButtonSeparator
} from './HeroRebrand.styled';
import { Typography } from '@latitude/typography';

const COMPONENT_ID = 'hero-rebrand';

/**
 * HeroRebrand component
 */
const Hero = ({
  heading,
  subHeading,
  backgroundImageUrl,
  primaryCta,
  secondaryCta,
  trackingId,
  ...rest
}) => {
  const componentIdentifier = trackingId
    ? `${trackingId}-${COMPONENT_ID}`
    : COMPONENT_ID;

  return (
    <StyledHeroContainer className={componentIdentifier} {...rest}>
      <StyledImageContainer
        className={`${componentIdentifier}-image-container`}
        style={{ backgroundImage: `url(${backgroundImageUrl})` }}
      >
        <Typography.H2 color={REBRAND_COLOR.WHITE}>{heading}</Typography.H2>
      </StyledImageContainer>
      <StyledTextWrapper>
        <StyledTextContainer className={`${componentIdentifier}-text-container`}>
        <Typography.Body color={REBRAND_COLOR.WHITE}>
          {subHeading}
        </Typography.Body>

        {(primaryCta || secondaryCta) && (
          <StyledButtonWrapper className={`${componentIdentifier}-cta-wrapper`}>
            {primaryCta && (
              <Typography.H4Link
                color={REBRAND_COLOR.WHITE}
                href={primaryCta.url}
                trackEventData={{
                  category: 'text-link',
                  location: 'hero-primary-cta',
                  label: primaryCta.text
                }}
                trackId={COMPONENT_ID}
              >
                {primaryCta.text}
              </Typography.H4Link>
            )}

            {secondaryCta && (
              <StyledButtonSeparator
                className={`${componentIdentifier}-cta-seperator`}
              />
            )}

            {secondaryCta && (
              <Typography.H4Link
                color={REBRAND_COLOR.WHITE}
                href={secondaryCta.url}
                trackEventData={{
                  category: 'text-link',
                  location: 'hero-secondary-cta',
                  label: secondaryCta.text
                }}
                trackId={COMPONENT_ID}
              >
                {secondaryCta.text}
              </Typography.H4Link>
            )}
          </StyledButtonWrapper>
        )}
      </StyledTextContainer>
            </StyledTextWrapper>
    </StyledHeroContainer>
  );
};

export default Hero;
